import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonInput,
  IonButton,
  IonItem,
  IonLabel,
  IonText,
  IonLoading,
  useIonRouter,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { SERVER_URL } from "../api/client";
import { Helmet } from "react-helmet-async";

const ResetPassword = () => {
  const router = useIonRouter();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const { token } = useParams();
  useEffect(() => {
    setPasswordMatch(password === confirmPassword || confirmPassword === "");
  }, [password, confirmPassword]);

  const handleSubmit = async () => {
    if (!password || !token) {
      setError("Missing token or password.");
      return;
    }

    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const res = await fetch(`${SERVER_URL}/profile/reset-password/${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Something went wrong.");
      }

      setMessage(data.message || "Password reset successful.");
      setTimeout(() => router.push("/signin", "forward"), 3000); // redirect after 3 sec
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <IonToolbar>
            <IonTitle>Reset Password</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          <IonItem>
            <IonInput
              type="password"
              placeholder="New Password"
              value={password}
              onIonChange={(e) => setPassword(e.detail.value)}
            />
          </IonItem>
          <IonItem>
            <IonInput
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onIonChange={(e) => setConfirmPassword(e.detail.value)}
            />
          </IonItem>
          {!passwordMatch && (
            <IonText color="danger">
              <p className="ion-padding-start">Passwords do not match.</p>
            </IonText>
          )}
          <IonButton
            expand="block"
            onClick={handleSubmit}
            className="ion-margin-top"
            disabled={!password || !confirmPassword || !passwordMatch}
          >
            Reset Password
          </IonButton>

          <IonLoading isOpen={loading} message="Resetting password..." />

          {message && (
            <IonText color="success">
              <p>{message}</p>
            </IonText>
          )}
          {error && (
            <IonText color="danger">
              <p>{error}</p>
            </IonText>
          )}
        </IonContent>
      </IonPage>
    </>
  );
};

export default ResetPassword;
